import {
    Illustration,
    Composite,
    Heading,
    Level,
    Text,
    TextType,
    useTheme,
} from '@defa/defa-component-library';
import { CloudchargeLogo } from '@assets/logos';

export function BrandPanel({ heading, subHeading }: { heading?: string; subHeading?: string }) {
    const theme = useTheme();
    return (
        <Composite>
            <Composite>
                <Illustration src={CloudchargeLogo} />
                <Heading level={Level.h4}>{heading}</Heading>
                {subHeading && (
                    <Text type={TextType.descriptionSmall} color={theme.listHeaderColor}>
                        {subHeading}
                    </Text>
                )}
            </Composite>
        </Composite>
    );
}
